<template>
  <article class="contact-us" :class="{ mobile: isMobile }">
    <img
      class="banner"
      src="@/assets/images/Global/contact_us_banner.png"
      alt="Electrify America chargers under a lighted canopy at night"
    />
    <div class="article-body text">
      <div class="container">
        <form name="commercial-contact-form" id="commercial-contact-form" @submit.prevent="validate" ref="form">
          <h1 class="header">Let’s power excellence together</h1>
          <p class="detail">
            The road to your electrified future begins now. Help us get to know you (and your project), and we’ll be in
            touch to discuss customized approaches to tackling your clients’ electrification needs.
          </p>
          <div class="form-wrap" :class="{ mobile: isMobile }">
            <label for="first_name"
              >First Name <span class="require-mark" aria-hidden="true">*</span>
              <input
                id="first_name"
                maxlength="55"
                name="first_name"
                pattern="^[A-Za-z '\-\.]+$"
                title="This field only accepts letters"
                type="text"
                v-model="answers['SuppliedFirstName']"
                required
              />
            </label>
            <label for="last_name"
              >Last Name <span class="require-mark" aria-hidden="true">*</span>
              <input
                id="last_name"
                maxlength="55"
                name="last_name"
                required
                pattern="^[A-Za-z '\-\.]+$"
                title="This field only accepts letters"
                type="text"
                v-model="answers['SuppliedLastName']"
              />
            </label>
            <label ref="email" for="email"
              >Business Email <span class="require-mark" aria-hidden="true">*</span>
              <input
                id="email"
                maxlength="55"
                name="email"
                required
                type="text"
                pattern="^[^\\]+@[^\\]+\.[^\\]+$"
                title="Please enter the correct email address"
                v-model="answers['SuppliedEmail']"
              />
            </label>
            <label for="phone"
              >Phone Number <span class="require-mark" aria-hidden="true">*</span>
              <input
                id="phone"
                maxlength="10"
                name="phone"
                v-model="answers['PhoneNumber']"
                type="text"
                pattern="^\d+$"
                title="This field only accepts numbers"
                required
              />
            </label>
            <label for="company_name"
              >Company Name <span class="require-mark" aria-hidden="true">*</span>
              <input
                id="company_name"
                maxlength="55"
                name="company_name"
                required
                pattern="^[^\\]+$"
                title="Please enter your company name (no special characters)"
                type="text"
                v-model="answers['CompanyName']"
              />
            </label>
            <label for="job_title"
              >Job Title <span class="require-mark" aria-hidden="true">*</span>
              <input
                id="job_title"
                maxlength="55"
                name="job_title"
                required
                pattern="^[^\\]+$"
                title="Please enter your title at the company (no special characters)"
                type="text"
                v-model="answers['JobTitle']"
              />
            </label>
            <label for="company_role"
              >Job Seniority<span class="require-mark" aria-hidden="true">*</span>
              <select id="company_role" name="company_role" v-model="answers['CompanyRole']" required>
                <option v-for="(item, index) in companyRoleOptions" :value="item" :key="index">{{ item }}</option>
              </select>
            </label>
            <label for="company_industry"
              >Company Industry <span class="require-mark" aria-hidden="true">*</span>
              <select v-model="answers['CompanyIndustry']" name="company_industry" id="company_industry" required>
                <option v-for="(item, index) in companyIndustryOptions" :value="item" :key="index">{{ item }}</option>
              </select>
            </label>
            <label v-if="answers['CompanyIndustry'] === 'Other'" for="company_industry_additional"
              >Please provide more details about the industry your company operates in<span
                class="require-mark"
                aria-hidden="true"
                >*</span
              >
              <input
                id="company_industry_additional"
                maxlength="55"
                name="company_industry_additional"
                required
                pattern="^[^\\]+$"
                title="Please enter the industry your company does business in (no special characters)"
                type="text"
                v-model="answers['AdditionalCompanyIndustry']"
              />
            </label>

            <label for="num_properties"
              >Number of Properties/Franchises <span class="require-mark" aria-hidden="true">*</span></label
            >
            <select v-model="answers['numberProperties']" name="num_properties" id="num_properties" required>
              <option v-for="(item, index) in numberPropertiesOptions" :value="item" :key="index">{{ item }}</option>
            </select>

            <label for="company_headquarters"
              >Where is your North American Company Headquarters Located?
              <input
                id="company_headquarters"
                maxlength="55"
                name="company_headquarters"
                pattern="^[^\\]+$"
                title="Please enter where your company is headquartered (no \)"
                type="text"
                v-model="answers['CompanyHeadquarters']"
              />
            </label>

            <label for="like_to">I am interested in <span class="require-mark" aria-hidden="true">*</span></label>
            <select v-model="answers['interestType']" name="like_to" id="like_to" required>
              <option v-for="(item, index) in interestTypeOptions" :value="item" :key="index">{{ item }}</option>
            </select>

            <label for="investment_amount"
              >How much do you expect to invest in electric vehicle charging infrastructure?
              <span class="require-mark" aria-hidden="true">*</span></label
            >
            <select v-model="answers['InvestmentAmount']" name="investment_amount" id="investment_amount" required>
              <option v-for="(item, index) in investmentAmountOptions" :value="item" :key="index">{{ item }}</option>
            </select>

            <div class="input-field checkbox">
              <label for="future-comm">
                <input
                  v-model="answers['OptMeinFutureComm']"
                  id="future-comm"
                  name="future-comm"
                  type="checkbox"
                  value="true"
                />
                <p class="form-question">I agree to receive further information from Electrify America*</p>
              </label>
              <br />
              <p class="form-question">*I am aware that I may unsubscribe to electronic communication at any time.</p>
              <br />
              <p class="form-question">
                Click <a href="https://www.electrifyamerica.com/privacy/" class="link">here</a> for Electrify America's
                Privacy Statement.
              </p>
            </div>
            <input ref="submitButton" class="button" name="Sign up" type="submit" value="SUBMIT" />
          </div>
          <p v-show="serverError !== ''" class="server-error">
            Error:
            <br />
            {{ serverError }}
          </p>
        </form>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  name: 'contactus',
  metaInfo: {
    title: 'Contact us | Electrify Commercial',
    script: [
      {
        type: 'application/ld+json',
        json: {
          '@context': 'http://schema.org',
          '@type': 'Organization',
          name: 'Electrify Commercial',
          url: 'https://www.electrify-commercial.com/',
          sameAs: [
            'https://twitter.com/electrifyam',
            'https://www.facebook.com/ElectrifyAmerica/',
            'https://www.instagram.com/electrifyamerica/?hl=en',
            'https://www.linkedin.com/company/electrifyamerica/about/',
          ],
          logo: 'https://twitter.com/electrifyam/photo',
          parentOrganization: {
            '@type': 'Organization',
            name: 'Electrify Commercial',
            url: 'https://www.electrify-commercial.com/',
          },
          contactPoint: [
            {
              '@type': 'ContactPoint',
              telephone: '+1-833-632-2778',
              contactType: 'customer support',
              contactOption: 'TollFree',
              areaServed: 'US',
            },
          ],
        },
      },
    ],
    meta: [
      {
        name: 'description',
        content: `Let's get to work. Electrify Commercial wants to hear from you. Fill out the form and we’ll get back to you soon.`,
      },
    ],
    link: [{ rel: 'canonical', href: 'https://www.electrify-commercial.com/contact-us/' }],
    noscript: [
      {
        innerHTML:
          '<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KXKDRHT" height="0" width="0" style="display:none;visibility:hidden"></iframe>',
        pbody: true,
      },
    ],
  },
  data() {
    return {
      serverError: '',
      numberPropertiesOptions: ['1-25', '26-50', '51-100', '101+'],
      interestTypeOptions: [
        'Hosting Charging Stations',
        'Owning a Charging Network',
        'Both Owning and Hosting Charging Stations',
      ],
      companyRoleOptions: ['Intern', 'Associate', 'Manager', 'Sr. Manager', 'Director', 'Executive', 'Founder/Owner'],
      investmentAmountOptions: ['$500K-$1M', '$1M-$5M', '$5M+', 'Unsure'],
      companyIndustryOptions: [
        'Convenience',
        'Fast Casual Restaurant',
        'Food & Beverage',
        'Fueling Center',
        'Grocery Store',
        'Mall/Shopping Center',
        'Retail',
        'Other',
      ],
      answers: {
        SuppliedFirstName: '',
        SuppliedLastName: '',
        SuppliedEmail: '',
        PhoneNumber: '',
        CompanyName: '',
        JobTitle: '',
        CompanyRole: '',
        CompanyIndustry: '',
        AdditionalCompanyIndustry: '',
        CompanyHeadquarters: '',
        numberProperties: '',
        interestType: '',
        InvestmentAmount: '',
        OptMeinFutureComm: '',
        Source: 'Commercial Web Form',
      },
    };
  },
  computed: {
    isMobile() {
      return this.$resize && this.$mq.below(950);
    },
  },
  methods: {
    async validate(e) {
      e.preventDefault();
      this.$refs.submitButton.disabled = true;
      this.serverError = '';
      try {
        const params = {
          site: 'ELAM',
          recaptchaToken: await this.recaptcha(),
          body: this.answers,
        };
        this.contactusPut(params);
      } catch (error) {
        console.error(error);
        this.$refs.submitButton.disabled = false;
        this.$gtm.trackEvent({
          event: 'interaction',
          category: 'form_failed',
          action: 'submit',
          form_id: 'commercial-contact-form',
          form_name: 'commercial-contact-form',
          label: 'Submission failed (network error)',
        });
      }
    },

    contactusPut(params) {
      const loader = this.$loading.show();
      this.$store.commit('setEmail', params.body.SuppliedEmail);
      this.$store
        .dispatch('putContactUs', params)
        .then((res) => {
          if (res.status === 'success') {
            this.$router.push({ name: 'email-verification-contact-us-en' });
          } else {
            this.serverError = res.errorMsg;
          }
          loader.hide();
          this.$refs.submitButton.disabled = false;
        })
        .catch((error) => {
          loader.hide();
          console.error(error);
          this.$refs.submitButton.disabled = false;
        });
    },
    async recaptcha() {
      try {
        // Wait for recaptcha loading
        await this.$recaptchaLoaded();
        // Execute reCAPTCHA with action "login" and return the token
        return await this.$recaptcha('login');
      } catch (e) {
        throw new Error('recaptcha login failed');
      }
    },
  },
  mounted() {
    this.$recaptchaLoaded().then(() => {
      this.$recaptchaInstance.showBadge();
    });
    /* eslint-disable */
    if (!window.PRERENDER_INJECTED) {
      (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', 'GTM-KXKDRHT');
    }
  },
  beforeDestroy() {
    this.$recaptchaInstance.hideBadge();
  },
};
</script>

<style lang="scss">
.contact-us {
  padding-top: 0 !important;
  .banner {
    width: 100vw;
    display: block;
    margin-bottom: 50px;
  }
  a {
    font-weight: 500;
  }
  p {
    font-size: 18px;

    span {
      font-size: 13px;
    }
  }

  position: relative;
  .header {
    text-align: initial;
    margin: 0 0 16px 0 !important;
    font-weight: bold;
    letter-spacing: 0.06px;
    line-height: 55px !important;
    font-size: 40px !important;
  }

  .email-link {
    text-decoration: underline;
  }

  .detail {
    font-size: 16px;
    color: #000000;
    font-weight: normal;
    letter-spacing: 0.03px;
  }

  .bg {
    height: 100%;
    overflow: hidden;
    position: absolute;
    top: 0;
    right: 0;

    img {
      height: 100%;
      width: 100%;
    }
  }

  .container {
    padding: 0 20px !important;
    margin: 0 auto 0 auto;
    max-width: 1200px !important;
    height: 100%;
    @media only screen and (min-width: 750px) {
      padding: 0 40px !important;
    }
  }

  form {
    max-width: 850px;
    width: 100%;
    margin-left: 100px;

    .form-question {
      color: #000000;
      font-weight: normal;
      font-size: 16px;
      span {
        font-size: 16px;
      }
    }

    .required {
      color: red;
    }

    .input-field {
      margin-bottom: 20px;
      position: relative;
    }

    select {
      background: url('../../assets/images/ContactUs/dropdown_arrow.png');
      -webkit-appearance: none;
      -moz-appearance: none;
      -o-appearance: none;
      appearance: none;
      background-repeat: no-repeat;
      background-size: 15px;
      margin-top: 2px;
      background-position: right 15px center;
      border: 1px solid #011352;
      border-radius: 8px;
      padding: 0 8px;
      height: 45px;
      color: #011352;

      span {
        color: red !important;
      }
    }

    label {
      font-size: 16px;
      color: #000000;
      font-weight: normal;
      letter-spacing: 0.03px;
    }

    ::placeholder {
      color: #011352;
      font-family: 'Ubuntu', Arial, sans-serif;
    }

    textarea {
      margin-top: 40px;
      border: 1px solid #011352;
      height: 120px;
      padding: 11px;
    }

    input[type='text'] {
      -webkit-appearance: none !important;
      border-radius: 0 !important;
    }

    input {
      margin-bottom: 10px !important;
      margin-bottom: 8px;
      -webkit-box-shadow: inset 0 -1px 0 0 #011352;
      box-shadow: inset 0 -1px 0 0 #011352;

      &:focus {
        outline: none;
        -webkit-box-shadow: inset 0 -1px 0 0 #bfc4d4;
        box-shadow: inset 0 -1px 0 0 #bfc4d4;
      }
    }

    input,
    textarea,
    select {
      transition: 500ms ease;
      box-sizing: border-box;
      max-width: 600px;
    }

    textarea,
    select {
      outline: none;
      &:focus {
        border: 1px solid #bfc4d4;
        -webkit-box-shadow: none;
        box-shadow: none;
      }
    }

    input[type='submit'] {
      width: 150px;
      padding: 22px 30px;
    }

    .disclaimer {
      font-size: 12px;
      line-height: 1.2 !important;
    }
  }

  .checkbox {
    label {
      display: flex;
    }
    p {
      flex: 1;
      margin: 0 !important;
      line-height: 1 !important;
    }
    input {
      width: fit-content;
      margin-bottom: 8px;
      -webkit-box-shadow: none;
      box-shadow: none;

      &:focus {
        outline: none;
        -webkit-box-shadow: none;
        box-shadow: none;
      }
    }
    span {
      margin-top: 8px;
      display: block;
      font-size: 18px;
    }

    .link {
      cursor: pointer;
      text-decoration: underline !important;
    }

    a {
      text-decoration: underline;
    }
  }
}

.contact-us.mobile {
  padding-top: 0px !important;
  form {
    width: 100%;
    max-width: 100%;
    margin-left: 0;
  }

  input,
  textarea,
  select {
    max-width: 100%;
  }

  .checkbox input {
    width: 25px;
    height: 25px;
  }
}
.residential-note {
  padding-left: 5px;
  color: #0b0f4d;
}

.prompt-for-details {
  color: black;
  font-weight: normal;
}
.prompt-hidden {
  display: none;
}
</style>
